import {Injectable} from '@angular/core';
import {UserAuthorisationService} from '../../../common/services/user-authorisation.service';
import {
  PaymentTypeFamily,
  PaymentTypeOption
} from '../../components/dialogs/pre-authorisation-payment-dialog/payment-type.enum';

@Injectable({
  providedIn: 'root'
})
export class PaymentsPermissionService {
  constructor(private userAuthorisationService: UserAuthorisationService) {
  }

  isUserAllowedToPayment(paymentTypeFamily: PaymentTypeFamily, paymentTypeOption?: PaymentTypeOption): boolean {
    let isUserAllowed = false;

    if (paymentTypeFamily == PaymentTypeFamily.Duplicate && this.isAuthorisedToAddDuplicatePayment()) {
      isUserAllowed = true;
    }
    else if (paymentTypeFamily == PaymentTypeFamily.Upfront && this.isAuthorisedToAddUpfrontPaymentOrUpfrontRefund()) {
      isUserAllowed = true;
    }
    else if (paymentTypeFamily == PaymentTypeFamily.Refund) {
      if (paymentTypeOption == PaymentTypeOption.UpfrontRefund) {
        isUserAllowed = this.isAuthorisedToAddUpfrontPaymentOrUpfrontRefund();
      }
      else if (paymentTypeOption == PaymentTypeOption.ClaimRefund) {
        isUserAllowed = this.isAuthorisedToAddClaimRefundPayment();
      }
      else {
        // Refund Button in Payment Screen should be enabled for both conditions
        // However edit/cancel icons are only enabled for the respective roles based on the payment type
        isUserAllowed = this.isAuthorisedToAddUpfrontPaymentOrUpfrontRefund() || this.isAuthorisedToAddClaimRefundPayment();
      }
    }
    else if (paymentTypeFamily == PaymentTypeFamily.Payment && this.isAuthorisedToAddPaymentRun()) {
      isUserAllowed = true;
    }
    return isUserAllowed;
  }

  private isAuthorisedToAddDuplicatePayment(): boolean {
    return this.userAuthorisationService.hasRoleFinancialTeamLeader();
  }

  private isAuthorisedToAddClaimRefundPayment(): boolean {
    return (
      this.userAuthorisationService.hasRoleFinancialManager() ||
      this.userAuthorisationService.hasRoleClaimsTeamLeader()
    );
  }

  private isAuthorisedToAddUpfrontPaymentOrUpfrontRefund(): boolean {
    return (
      this.userAuthorisationService.hasRoleFinancialManager() ||
      this.userAuthorisationService.hasRolePreAuthorisationManager()
    );
  }

  private isAuthorisedToAddPaymentRun(): boolean {
    return this.userAuthorisationService.hasRoleFinancialManager();
  }

}
